<template>
  <div class="matching__table">
    <div class="matching__table__head">
      <div class="matching__table__cell">№</div>
      <div class="matching__table__cell">ФИО сотрудника в МИС</div>
      <div class="matching__table__cell align">{{ externalEmployeesColumnHeadTitle }}</div>
    </div>
    <div
      class="matching__table__row"
      v-for="employee in employees"
      v-bind:key="employee.getId()">
      <div data-label="№" class="matching__table__cell number" />
      <div data-label="ФИО врача" class="matching__table__cell">
        {{ employee.getName() }}
      </div>
      <div
        class="matching__table__cell align"
        v-bind:data-label="externalEmployeesColumnHeadTitle"
      >
        <input-autocomplete
          clearable
          hide-details
          no-data-text="Результатов нет"
          option-title-key="name"
          option-value-key="id"
          title=""
          v-bind:options="externalEmployees"
          v-bind:value="employee.getExternalId()"
          v-on:input="onInput(employee, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputAutocomplete from '@/components/InputAutocomplete.vue';

/**
 * @description Название события связывания сотрудников.
 * @type {string}
 */
const NAME_EVENT_LINK_EMPLOYEE = 'link-employee';

/**
 * @description Компонент сопоставления сотрудников МИС с сотрудниками внешней системы.
 * @type {Vue}
 */
export default {
  components: { InputAutocomplete },
  methods: {
    /**
     * @description Обработать ввод.
     * @param {Employee} employee
     * @param {?number}  externalEmployeeId
     * @returns {void}
     */
    onInput(employee, externalEmployeeId) {
      this.$emit(NAME_EVENT_LINK_EMPLOYEE, employee, externalEmployeeId);
    },
  },
  name: 'MatchingExternalEmployees',
  props: {
    /**
     * @description Сотрудники.
     */
    employees: { required: true, type: Array },
    /**
     * @description Сотрудники внешней системы.
     */
    externalEmployees: { required: true, type: Array },
    /**
     * @description Заголовок колонки сотрудников внешней системы.
     */
    externalEmployeesColumnHeadTitle: { required: true, type: String },
  },
};
</script>

<style scoped lang="scss">

.matching {
  &__table {
    counter-reset: counterEmployees;
    background: #FFFFFF;
    margin: 35px 0 0 0;
    &__head,
    &__row {
      align-items: center;
      cursor: pointer;
      display: grid;
      font-size: 14px;
      grid-template-columns: 40px 1fr 1fr;
      line-height: 17px;
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489E0;
      padding: 10px 0;
    }
    &__row {
      border-bottom: 1px solid #EAEFF3;
      padding: 12px 0;
      align-items: flex-end;
      &:hover {
        background: #EAEFF3;
      }
    }
    &__cell {
      padding: 0 8px;
      position: relative;
      &.number:after {
        counter-increment: counterEmployees;
        content: counter(counterEmployees);
      }
      &.align {
        text-align: center;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .matching  {
    &__table {
      &__head {
        display: none;
      }
      &__row {
        grid-template-columns: 1fr;
        grid-gap: 10px;
        margin: 0 0 20px 0;
      }
      &__cell {
        display: flex;
        justify-content: space-between;
        text-align: right;
        font-size: 12px;
        align-items: center;
      }
      &__cell:before {
        content: attr(data-label);
        font-weight: 700;
        margin-right: 20px;
        font-size: 10px;
        text-align: left;
      }
    }
  }
}
</style>
